var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-list-page"},[_c('div',{staticClass:"contract-list-page__content"},[_c('instruction',{attrs:{"page":'contractList'}}),_vm._v(" "),_c('contract-list-overview')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f81a808","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContractListPage/ContractListPage.vue
// module id = null
// module chunks = 